// extracted by mini-css-extract-plugin
export default {"confirmMessage":"_ReservateConfirm_confirmMessage__B5+ws","reservateConfirmTitle":"_ReservateConfirm_reservateConfirmTitle__zfu+A"};